import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';
import type { AdminFeedbackListResponseDto, AdminFeedbackFiltersDto } from '@/types/dto.types';

export const adminFeedbackService = {
  async list(filters?: AdminFeedbackFiltersDto): Promise<AdminFeedbackListResponseDto> {
    const response = await api.get<ApiResponse<AdminFeedbackListResponseDto>>(
      API_ENDPOINTS.FEEDBACKS.ADMIN_LIST,
      { params: filters }
    );
    return response.data.data;
  },

  async markAddressed(id: string, note: string): Promise<void> {
    await api.patch(API_ENDPOINTS.FEEDBACKS.MARK_ADDRESSED(id), { note });
  },

  async unmarkAddressed(id: string): Promise<void> {
    await api.patch(API_ENDPOINTS.FEEDBACKS.UNMARK_ADDRESSED(id));
  },
};
